import { TProjectsListState } from 'shared/reducers';

export const selectProjects = (state: TProjectsListState) => {
  return state.projects;
};
